import { Component, inject, Input, OnDestroy, OnChanges, SimpleChanges, ChangeDetectorRef, NgZone } from '@angular/core';
import { BaseComponent } from '../../base/components/base.component';
import { CspNonceService } from '../../shared/service/csp-nonce.service';
import { ProductService } from '../../shared/service/product.service';


import { ApexOptions, NgApexchartsModule } from 'ng-apexcharts';
import { PlantPerformanceResponse } from '../../shared/models/pr-cuf-response';
import { TranslateModule } from '@ngx-translate/core';

import {  Subject } from 'rxjs';

@Component({
    selector: 'app-puf',
    imports: [TranslateModule, NgApexchartsModule],
    templateUrl: './puf.component.html',
    styleUrl: './puf.component.scss'
})
export class PufComponent extends BaseComponent implements OnDestroy, OnChanges

{
  @Input() plantID!: string;
  productService = inject(ProductService)
  cdr = inject(ChangeDetectorRef)
  ngZone = inject(NgZone)
  readonly  destroy$ = new Subject<void>();
  constructor(private readonly cspNonceService: CspNonceService) {
    super();
  }
 
  chartOptions!: ApexOptions;
  showChart = false;
 
  getCfPufGeneration(): void {
    this.productService
      .getPrCufData(this.plantID)
      .subscribe({
        next: (response: PlantPerformanceResponse) => {
          const performanceData = response?.data?.performanceData ?? [];

          if (!performanceData.length) {
            return;
          }


          performanceData.sort(
            (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
          );

          const dates = performanceData.map(item =>
            new Date(item.date)
              .toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short'
              })
              .toUpperCase()
          );

          const prValues = performanceData.map(item =>
            Number(item.pr.replace('%', '').trim())
          );

          const cufValues = performanceData.map(item =>
            Number(item.cuf.replace('%', '').trim())
          );

          this.plotCrPufGraph(dates, prValues, cufValues);
          this.showChart = true;
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          this.ngZone.run(() => {
            this.logger.error(err);
          });
        }
      });
  }
  plotCrPufGraph(dates: string[], prValues: number[], cufValues: number[]): void {
    const nonce = this.cspNonceService.getNonce() ?? undefined;
    this.chartOptions = {
      series: [
        {
          name: 'Performance Ratio',
          data: prValues
        },
        {
          name: 'Capacity Utilization Factor',
          data: cufValues
        }
      ],

      chart: {
        type: 'bar',
        height: '309',
        width: '100%',
        nonce: nonce,
        stacked: false,
        parentHeightOffset: 0,
        redrawOnParentResize: true,
        toolbar: { show: true }
      },

      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '32%',
          borderRadius: 0,
          distributed: false
        }
      },

      dataLabels: {
        enabled: false
      },

      xaxis: {
        categories: dates,
        labels: {
          style: {
            colors: '#AEB9E1',
            fontSize: '12px'
          }
        }
      },

      yaxis: {
        labels: {
          formatter: (val: number) => `${val}%`,
          style: {
            colors: '#AEB9E1'
          }
        },

        title: {
          text: 'Per Hour Generation',

        }

      },

      colors: ['#6B80C0', '#D58F2D'],

      legend: {
        position: 'bottom',
        horizontalAlign: 'center',
        labels: {
          colors: '#AEB9E1'
        }
      },

      tooltip: {
        y: {
          formatter: (val: number) => `${val}%`
        }
      },

      grid: {
        borderColor: '#2E3440'
      }
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['plantID'] && this.plantID) {
      this.getCfPufGeneration();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


}
